var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"subscription-box-edition-list"},[_c('snowflake-search-list',{attrs:{"context":"subscription-box-edition","service":_vm.subscriptionBoxEditionService}},[_c('template',{slot:"tableRows"},[_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('edition.edition'),"sortable":""}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }